import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'comma2space'
})
export class Comma2spacePipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    if (!content) return null;

    // 콤마 뒤에 바로 문자가 오는 경우를 찾아 해당 위치에 공백을 추가한다.
    const result = content.replace(/,(\S)/g, ', $1');
    return result;
  }

}
